import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../images/circle-info-regular-full.svg'

function ReviewsRating ({ localReviewsRangeQuery, setLocalReviewsRangeQuery }) {
  const handleMinChange = e => {
    const min = e.target.value || undefined
    setLocalReviewsRangeQuery(prev => ({
      ...prev,
      min
    }))
  }

  const handleMaxChange = e => {
    const max = e.target.value || undefined
    setLocalReviewsRangeQuery(prev => ({
      ...prev,
      max
    }))
  }

  return (
    <section className={styles.reviewsModalSection}>
      <h1 className={styles.reviewsModalTitle}>Reviews</h1>

      <div className={styles.reviewsModalContainer}>
        <div className={styles.inlineLabel}>
          <label className={styles.reviewsModalLabel} htmlFor='key'>
            Contains reviews with ratings
          </label>
          <Tooltip
            title='Filter by review star ratings. Choose a minimum and/or maximum (1–5).'
            arrow
            placement='top'
            slotProps={{
              popper: {
                sx: {
                  '& .MuiTooltip-tooltip': {
                    maxWidth: 500,
                    fontSize: '13px',
                    padding: '8px'
                  }
                }
              }
            }}
          >
            <img
              src={infoIcon}
              alt='Reviews rating help'
              width={14}
              height={14}
              className={styles.infoIcon}
              tabIndex={0}
            />
          </Tooltip>
        </div>

        <div style={{ display: 'flex', gap: '16px' }}>
          <div className={styles.reviewsModalColumn}>
            <select
              className={styles.reviewsModalDropdown}
              name='minRating'
              id='minRating'
              value={localReviewsRangeQuery?.min}
              onChange={handleMinChange}
            >
              <option value=''>Min</option>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
            </select>
          </div>

          <div className={styles.reviewsModalColumn}>
            <select
              className={styles.reviewsModalDropdown}
              name='maxRating'
              id='maxRating'
              value={localReviewsRangeQuery?.max}
              onChange={handleMaxChange}
            >
              <option value=''>Max</option>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
            </select>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ReviewsRating
